import React from "react";
import { Switch, Route } from "react-router-dom";
import TransferPage from "./Pages/TransferPage";
import NFTTransferPage from "./Pages/NFTTransferPage";
import HomePage from "./Pages/HomePage";
import ConfigurePage from "./Pages/ConfigurePage";
import OnRampPage from "./Pages/OnRampPage";

const FilesRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" component={HomePage} />
      <Route path="/configure" component={ConfigurePage} />
      <Route path="/onramp" exact component={OnRampPage} />
      <Route path="/bridge" component={TransferPage} />
      <Route path="/nftbridge" component={NFTTransferPage} />
      <Route render={() => "404 page not found !"} />
    </Switch>
  );
};

export default FilesRoutes;
